import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Material
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { FilesViewerModalComponent } from './files-viewer-modal.component';

@NgModule({
  declarations: [FilesViewerModalComponent],
  exports: [FilesViewerModalComponent],
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule],
})
export class FilesViewerModalModule {}
